import styled from "@emotion/styled";

export const MenuBody = styled.div`
  padding-block-end: 120px;
  padding-inline: 24px;
`;
